module.exports = __webpack_public_path__ + "img/TXG_DISAsset10Oneclick.bf44c459.svg";